import React, { useState, useEffect, useRef } from "react";
import { BlueButton, DullButton } from "../../../../ReusableComponents/GetButtons/GetButtons"
import "../../../../ReusableComponents/GetButtons/getButton.css"
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import RedTriangle from "../../../../ReusableComponents/Alert/Icons/RedTriangle.svg"
import ImportPicklist from "./ImportPicklist"
import axios from '../../../../axios';
import CustomizedAlert from '../../../../ReusableComponents/Alert/CustomizedAlert';


// const isWebKit = 'WebkitAppearance' in document.documentElement.style;
// const isMozilla = 'MozAppearance' in document.documentElement.style;


const useStyle = makeStyles(() => ({
  backShade: {
    zIndex: "1201",
    height: "100%",
    width: "100%",
    background: "#00000067",
    position: "absolute",
    top: 0
  },
  createNew_PopUp: {
    display: "flex",
    flexDirection: "column",
    direction: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "rtl" : "ltr",
    position: "absolute",
    zIndex: "1202",
    left: "50%",
    top: "10vh",
    // height:"35vh",width:"520px",
    // height:"240px",
    width: "422px",
    // height: "352px",
    background: "#fff",
    border: "1px solid #00000040",
    transform: "translate(-50%,0)"
  },
  createNew_PopUp_Publish: {
    display: "flex",
    flexDirection: "column",
    direction: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "rtl" : "ltr",
    position: "absolute",
    zIndex: "1202",
    left: "50%",
    top: "10vh",
    // height:"35vh",width:"520px",
    // height:"240px",
    width: "422px",
    height: "312px",
    background: "#fff",
    border: "1px solid #00000040",
    transform: "translate(-50%,0)"
  },
  createNew_PopUp_header: {
    borderBottom: "1px solid #00000040",
    textAlign: (style) => (style.translationStyles1 ? "right" : "left"),
    fontSize: "14px",
    fontWeight: "600",
    padding: "0 18px",
    height: "50px",
    lineHeight: "50px"
  },
  createNew_PopUp_body: {
    padding: "0px 18px",
    minHeight: "28vh",
    overflowY: "auto",
    height: "fit-content",
    backgroundColor: "white",
    "& div": {
      // display:"flex",
      margin: "7px 0",
      justifyContent: "space-between"
    },
    "& label": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#606060",
      display: "block",
      textAlign: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "right" : "left",
      // marginTop:"1em",
      minWidth: "100px",
      lineHeight: "28px"
    },
    "& input, & textarea": {
      display: "block",
      textAlign: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "right" : "left",
      // width: "-webkit-fill-available",
      // width: "-moz-available",
      width: "100%",
      // width: isWebKit ? '-webkit-fill-available' : isMozilla ? '-moz-available' : '100%',
      resize: "none",
      padding: "0 5px",
      fontSize: "12px",
      height: "28px",
      border: "1px solid #C4C4C4",
      borderRadius: "2px",
      // marginLeft:"5px",
      "&:focus , &:focus-visible , &:hover": {
        border: "1px solid #C4C4C4",
        outline: "none"
      }
    },
    "& textarea": {
      height: "95px"
    }
  },
  createNew_PopUp_footer: {
    textAlign: (style) => (style.translationStyles1 ? "left" : "right"),
    background: "#F5F5F5",
    boxSizing: "border-box",
    height: "50px",
    padding: "10px 10px",
    marginTop: "auto",
    "& button": {
      margin: "0 6px !important",
      fontSize: "12px",
      height: "28px",
      minWidth: "54px"
    }
  },
  errorMsg: {
    color: "red",
    fontSize: "12px",
    lineHeight: "20px",
    marginLeft: "7px !important"
  },
  inputWrapper: {
    flexDirection: "column",
    width: "-moz-available"
  },
  dataObjectHeading: {
    background: "#F0F0F0 0% 0% no-repeat padding-box",
    height: "32px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "13px",
    fontSize: "12px",
    fontWeight: 600,
    margin: "7px 0px 0px 0px !important"
  },
  infoHeding: {
    background: "#E1B01114 0% 0% no-repeat padding-box",
    height: "32px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "13px",
    fontSize: "11px"
  },
  mainHeding: {
    font: "normal normal normal 12px/20px Open Sans",
    height: "auto",
    display: "flex",
    alignItems: "center",
    color:"#B52A2A"
  },
  alertImg: {
    width: "27px",
    paddingLeft: "13px"
  },
  objectList: {
    fontSize: "12px",
    fontFamily: "Open Sans",
    paddingLeft: "10px"
  },
  objectWrap: {
    height: "32px",
    border: "1px solid #F0F0F0",
    margin: "0px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start !important"
  },
  mainWrap: {
    height: "fit-content",
    overflowY: "auto",
    margin: "0px !important",
    marginBottom: "5px !important"
  },
  separator: {
    border: "1px solid #00000030",
    margin: "15px 0"
  }
}));

function PicklistValidationModal(props) {
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
});
  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const classes = useStyle({ translationStyles1 });
  const { t } = useTranslation();
  const { handleFailedClose, failedDoData, failedAssocData = "" } = props;
  const [importPicklist, setImportPicklist] = useState(false);
  const fileRef = useRef(null);

  const handleModal = () => {
    props.setOpenPicklistValidationModal(false);
  };

  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      handleModal()
    }
  }
  const onButtonClick = (evt) => {
    evt.stopPropagation();
    fileRef.current.click();
    //  console.log("test click called button clicked")
  };

  const handleImportPicklist = (e) => {
    try {
      const file = e.target.files[0];
      var theFile = document.getElementById("myFile");
      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      fileReader.onload = async (e) => {
        let parseJson = JSON.parse(e.target.result);
        const size = new TextEncoder().encode(e.target.result).length;

        const response = await axios.post('/idesign/importpicklistinstance', {
          picklist_instances: parseJson?.data?.picklist_instances,
          filename: file.name,
          filetype: file.type,
        }, { withCredentials: true });
        // console.log("shalvi",response);
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "success",
          alertContentMsg: "The picklist has been imported successfully.",
          // autoHideDuration: 6000,
        });
        setTimeout(()=>{
          props.setOpenPicklistValidationModal(false);
        },1000)

      };
    } catch (err) {
      console.error(err);
    }
  }



  const [finalMapData, setFinalMapData] = useState([]);
  useEffect(() => {
    const mapData1 = [];
    props?.validationResponse?.forEach((valid1) => {
      props?.formdata?.picklistInstanceArray?.forEach((pick1) => {
        if (valid1 === (pick1?.picklist_instance_id + "")) {
          mapData1.push({ picklist_instance_id: valid1,picklist_name:pick1?.picklist_name, pickId: pick1?.id })
        }
      })
    })
    setFinalMapData(mapData1)

  }, [props?.validationResponse, props?.formdata?.picklistInstanceArray])


  return (
    <>
      <div className={classes.backShade}></div>
      <div tabIndex="0" onKeyDown={e => handleEscapeKey(e)} className={props.iterfacePageAndSubform ? classes.createNew_PopUp_Publish : classes.createNew_PopUp}>
        <div className={classes.createNew_PopUp_header}>
          Failed Picklist Associations
        </div>

        <div className={classes.createNew_PopUp_body}>
          <div className={classes.mainHeding}>
          {finalMapData && finalMapData.length>0 ? finalMapData.length :null} Picklist Associations for this imported form have failed to import.
          </div>

          <div className={classes.mainWrap}>
          <table style={{width:"100%"}}>
        <thead style={{textAlign:"left"}}>
          <tr>
            <th>Picklist Name</th>
            <th>Mapped Form Control ID</th>
          </tr>
        </thead>
        <tbody>
        {finalMapData &&
              finalMapData.length > 0 &&
              finalMapData.map((item) => (
                <tr style={{background: "#F0F0F0 0% 0% no-repeat padding-box"}}>
                  <td>{item.picklist_name}</td>
                  <td>{item.pickId}</td>
                </tr>
                  
                  // <p className={classes.objectList}>{`${item.picklist_name} for Form Control ID ${item.pickId}`}</p>
              ))}
        </tbody>
        </table>

           
          </div>
          <div style={{background: "#9BDDF3 0% 0% no-repeat padding-box"}}>
            <div>
            To fix this, you can download these picklists from the source form and then import them using the button below.
            </div>
          </div>
          
        </div>

        <div className={classes.createNew_PopUp_footer}>
          <DullButton className="dull-button" onClick={handleModal}>{t("Cancel")}</DullButton>
          <BlueButton className="blue-button" onClick={(e) => onButtonClick(e)}>{t("Import Picklists")}</BlueButton>
          <input
            aria-label={"Import Picklists"}
            id="myFile"
            hidden
            ref={fileRef}
            type="file"
            onChange={(e) => handleImportPicklist(e)}
            accept=".json,application/json"
          />
        </div>
      </div>
      {
              alertData.open === true &&
            <CustomizedAlert alertData={alertData} />
            }
    </>
  );
}

export default PicklistValidationModal;
